export default __webpack_public_path__ + "static/media/logo.350ac5e2.png";